import { AbstractControl, ValidationErrors } from '@angular/forms';
import { UserAccountService } from '../../core/data/user-account.service';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, take, map, tap, switchMapTo, debounceTime } from 'rxjs/operators';



export class IsUniqueValidator {

    static createUniqueValidator(service: UserAccountService, isStudentId: boolean) {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (!control.valueChanges || control.pristine)
                return of(null);
            else
                return control.valueChanges.pipe(
                    debounceTime(300),
                    distinctUntilChanged(),
                    take(1),
                    switchMapTo(service.checkUniqueness(control.value, isStudentId)),
                    tap(() => control.markAsTouched()),
                    map((data) => (data === true ? { userExist: true } : null))
                );
        };
    }

}
